import {Tag} from './tag';
export function matchesTaggedText(record: {name: string; comment?: string | null; tags?: Tag[]}, query: string): boolean {
  const fields = [record.name, record.comment ?? '', ...(record.tags ?? []).map(tag => tag.name)].map(text => text.toLocaleLowerCase());
  return query.trim().toLocaleLowerCase().split(/\s+/).every(token => fields.some(field => field.includes(token)));
}
